import { getApi } from "../../services/httpService";


export function floorIcon(){
    return getApi().get('home/floorPlan/iconlist');
}
